import { StyledLabels, Label, LABEL_TOP_NAME } from './styled';

const Labels = ({ position, config }) => {
    const { labels, gridSize } = config;
    const count = position === LABEL_TOP_NAME ? gridSize[0] : gridSize[1];

    const getLabel = (index) => {
        if (labels.type === 'coordinate') {
            const [min, max] = labels.range;
            if (position === LABEL_TOP_NAME) {
                return min + index;
            }
            return max - 1 - index;
        }
        if (position === LABEL_TOP_NAME) {
            return String.fromCharCode(index + 65);
        }
        return index + 1;
    };

    return (
        <StyledLabels position={position} count={count}>
            {[...Array(count).keys()].map((index) => (
                <Label key={index} $position={position}>
                    {getLabel(index)}
                </Label>
            ))}
        </StyledLabels>
    );
};

export { LABEL_TOP_NAME };
export { LABEL_LEFT_NAME } from './styled';
export default Labels;
